import { render, staticRenderFns } from "./NotificationPreferencesPanel.vue?vue&type=template&id=5af80661&scoped=true"
import script from "./NotificationPreferencesPanel.vue?vue&type=script&lang=js"
export * from "./NotificationPreferencesPanel.vue?vue&type=script&lang=js"
import style0 from "./NotificationPreferencesPanel.vue?vue&type=style&index=0&id=5af80661&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af80661",
  null
  
)

export default component.exports